export const NOT_CREATED_ALERT = 'NOT_CREATED_ALERT';
export const CREATED_ALERT = 'CREATED_ALERT';
export const CREATED_ALERT_LABEL_INVISIBLE = 'CREATED_ALERT_LABEL_INVISIBLE';

export function hasAlreadyCreatedAlert(alerts, location) {
    return alerts.filter((alert) => alert.attributes.params.place === location).length > 0;
}
